var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350.66 156.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M336.34,14.33c-19.09-19.1-50.05-19.1-69.15-.01l-4.55,4.55-4.55-4.55C248.93,5.15,236.49,0,223.53,0c-21.66,0-40.02,14.09-46.44,33.6-.56,1.71-2.97,1.67-3.53-.04-2.37-7.18-6.39-13.78-11.84-19.23-19.09-19.1-50.05-19.1-69.15-.01l-4.55,4.55-3.98-3.98C74.74,5.59,62.22.05,49.09,0,21.99-.1,0,21.83,0,48.9c0,65.24,80.33,104.93,83.74,106.59,1.33.65,2.79.98,4.27.98,1.48,0,2.95-.33,4.28-.98,3.06-1.5,67.62-33.6,81.22-86.86.48-1.89,3.13-1.89,3.61,0,13.57,53.44,78.19,85.38,81.24,86.86,1.33.65,2.79.98,4.27.98,1.48,0,2.95-.33,4.28-.98,3.42-1.68,83.73-41.6,83.73-106.59,0-12.97-5.15-25.4-14.32-34.57Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.3698e4ede4a42acf08b695ae8e387804.svg";
export { ForwardRef as ReactComponent };